<template>
  <div>
    <b>Credence Appcomponents Liabrary...</b>
    <!-- <hr>
      <macro /><br>
    <hr> -->
    <!-- <hr /> -->
    <!-- <mega-menu-web-component /> -->
    <!-- <hr /> -->

    <!-- <hr />
    <file-upload />
    <hr /> -->

    <!-- <search /> -->
    <!-- <MegaMenuWebComponent /> -->
    <macromenuoptions />
  </div>
</template>

<script>
// import Macro from "../../../StandaloneWebComponent/macro.vue";
// import MegaMenuWebComponent from "../../../StandaloneWebComponent/MegaMenuWebComponent.vue";
// import MegaMenu from "../../../components/MegaMenu/MegaMenu.vue";
// import FileUpload from "../../../StandaloneWebComponent/FileUpload.vue";
// import Search from "../../../StandaloneWebComponent/search.vue";
import macromenuoptions from "../macro/macro.vue";

export default {
  name: "app1",
  components: {
    // Macro,
    // MegaMenuWebComponent,
    // MegaMenu,
    // FileUpload,
    macromenuoptions,
    // Search
  },
};
</script>
